import React from 'react';
import styled, { css } from 'styled-components';
import { SalesPrice, ListPrice } from '../atoms/price';
import Installment from '../atoms/installment';
import Discount from '../atoms/discount-badge';

const PriceInfo = ({ price, className }) => (
  <Wrapper className={className}>
    <ContainerSalesDiscount gap="10px">
      <SalesPrice {...price} />
      <Discount {...price} />
    </ContainerSalesDiscount>
    <ContainerPriceInstalmentCash gap="2px">
      <ListPrice {...price} />
      <InstallmentUI {...price} />
    </ContainerPriceInstalmentCash>
  </Wrapper>
);

export default PriceInfo;

const Wrapper = styled.div``;

const Container = styled.div`
  ${({ gap }) => css`
    display: grid;
    gap: ${gap};
  `}
`;

const ContainerPriceInstalmentCash = styled(Container)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

const ContainerSalesDiscount = styled(Container)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;

  &:empty {
    height: 14px;
  }
`;
const InstallmentUI = styled(Installment)`
  height: 42px;
`;
